import React from "react";
const Sup = () => {
  return <sup className="error-message mr-1">*</sup>;
};
export default Sup;

